
import React from 'react';

export default class Modal extends React.Component {

    render() {
        return (
            <div className="modal">
                <div className="modal-inner">
                    <div className="modal-content">
                        <h2>{this.props.title}</h2>
                        <p dangerouslySetInnerHTML={{__html: this.props.text}}></p>
                        <div className="modal-footer">
                            {this.props.buttons && this.props.buttons.map((button,index) =>
                                <button
                                    key={index}
                                    className={"big-button black" + (button.style=="primary" ? "" : " outline")}
                                    onClick={() => {
                                        if (button.onClick) {
                                            button.onClick();
                                        }
                                        if (this.props.onClose) {
                                            this.props.onClose();
                                        }
                                    }}
                                >{button.label}</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
